import {
  GetRecyclingPackageProductByIdRequestParams,
  GetRecyclingPackageProductsRequestParams,
  GetRecyclingProductsRequestParams,
  PostRecyclingPackageProductRequestBody,
  PutRecyclingPackageProductReqeustBody,
  UpsertRecyclingProductRequestBody,
} from '@/src/apis/rest/recyclingProducts.dtos';
import request from '@/src/apis/axios';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';
import {
  RecyclingPackageProductDto,
  RecyclingProductDto,
} from '@/src/models/RecyclingProductDto';

const URL = {
  recyclingProducts: '/admin/recycling-products',
  recyclingProductsDetail: '/admin/recycling-products/{id}',
  recyclingProductsExcel: '/admin/recycling-products/excel/export',
  recyclingPackageProducts: '/admin/recycling-package-products',
  recyclingPackageProductsDetail: '/admin/recycling-package-products/{id}',

  recyclingPackageProductsUnits: '/recycling-package-products/units',
};

export const getRecyclingPackageProductsUnits = async () => {
  const { data } = await request<any>({
    method: 'get',
    url: URL.recyclingPackageProductsUnits,
  });

  return data.rows;
};

export const getRecyclingProductsAPI = async (
  requestParams: Partial<GetRecyclingProductsRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<RecyclingProductDto>>({
    method: 'get',
    url: URL.recyclingProducts,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(RecyclingProductDto, data.rows);

  return { rows, count: data.count };
};

export const getRecyclingProductsByIdAPI = async (id: number) => {
  const { data } = await request<ObjectResponse<RecyclingProductDto>>({
    method: 'get',
    url: URL.recyclingProductsDetail.replace('{id}', String(id)),
  });

  return plainToInstance(RecyclingProductDto, data.row);
};

export const getRecyclingProductsExcelAPI = async (
  password: string,
  requestParams: Partial<GetRecyclingProductsRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.recyclingProductsExcel,
    queryParams: { ...requestParams, password },
    config: { responseType: 'blob' },
  });

  return data;
};

export const postRecyclingProductAPI = async (
  requestBody: UpsertRecyclingProductRequestBody,
) => {
  const { data } = await request<ObjectResponse<RecyclingProductDto>>({
    method: 'post',
    url: URL.recyclingProducts,
    requestBody,
  });

  return plainToInstance(RecyclingProductDto, data.row);
};

export const putRecyclingProductAPI = async (
  id: number,
  requestBody: UpsertRecyclingProductRequestBody,
) => {
  const { data } = await request<ObjectResponse<RecyclingProductDto>>({
    method: 'put',
    url: URL.recyclingProductsDetail.replace('{id}', String(id)),
    requestBody,
  });

  return plainToInstance(RecyclingProductDto, data.row);
};

export const getRecyclingPackageProductsAPI = async (
  requestParams: Partial<GetRecyclingPackageProductsRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<RecyclingPackageProductDto>>({
    method: 'get',
    url: URL.recyclingPackageProducts,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(RecyclingPackageProductDto, data.rows);

  return { rows, count: data.count };
};

export const getRecyclingPackageProductsByIdAPI = async ({
  id,
}: Partial<GetRecyclingPackageProductByIdRequestParams>) => {
  const { data } = await request<ObjectResponse<RecyclingPackageProductDto>>({
    method: 'get',
    url: URL.recyclingPackageProductsDetail.replace('{id}', String(id)),
  });

  return plainToInstance(RecyclingPackageProductDto, data.row);
};

export const postRecyclingPackageProducts = async (requestBody: any) => {
  const { data } = await request<any>({
    method: 'post',
    url: URL.recyclingPackageProducts,
    requestBody,
  });

  return plainToInstance(RecyclingProductDto, data.row);
};

export const putRecyclingPackageProductAPI = async (
  requestBody: PutRecyclingPackageProductReqeustBody,
) => {
  const { id, ...rest } = requestBody;

  const { data } = await request<ObjectResponse<RecyclingPackageProductDto>>({
    method: 'put',
    url: URL.recyclingPackageProductsDetail.replace('{id}', String(id)),
    requestBody: rest,
  });

  return plainToInstance(RecyclingPackageProductDto, data.row);
};
